import { SVGProps } from "react";

const FilterRemove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.72477 13.1212L7.88194 13.6652C7.09889 14.1494 6.01099 13.6054 6.01099 12.6371V9.4391C6.01099 9.0147 5.77189 8.47075 5.52681 8.17188L3.23145 5.75695C2.9266 5.45209 2.6875 4.91414 2.6875 4.54952V3.16273C2.6875 2.43946 3.23145 1.89551 3.89495 1.89551H11.8689C12.5324 1.89551 13.0764 2.43947 13.0764 3.10297V4.42996C13.0764 4.91414 12.7715 5.51787 12.4727 5.81674"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5781 9.52832C13.5781 10.0436 13.4334 10.5299 13.1787 10.9467C12.7039 11.7457 11.8297 12.2783 10.8281 12.2783C9.82655 12.2783 8.95234 11.7399 8.4776 10.9467C8.22286 10.5357 8.07812 10.0436 8.07812 9.52832C8.07812 8.01148 9.31128 6.77832 10.8281 6.77832C12.345 6.77832 13.5781 8.01148 13.5781 9.52832Z"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4449 10.1275L10.2227 8.90527"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4332 8.92383L10.2109 10.1461"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default FilterRemove;
